import {FormsModule} from "@angular/forms";
import {DatePipe, NgClass} from "@angular/common";
import {Component, inject, Input, OnInit} from '@angular/core';

import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

import {appRoutes} from "@numizmat/constants";
import {ModalService} from "@numizmat/services/common";
import {InvoiceApiService} from "@numizmat/services/core";
import {RestoreScrollPositionDirective} from "@numizmat/directives";
import {InvoiceResponse, OwnProfileResponse} from "@numizmat/services-models/core";
import {
  PaymentModalComponent
} from "@numizmat/pages/profile-page/components/own-profile/modals/payment-modal/payment-modal.component";

@Component({
  selector: 'nz-profile-wallet',
  standalone: true,
  imports: [
    NgClass,
    DatePipe,
    FormsModule,
    RestoreScrollPositionDirective
  ],
  templateUrl: './profile-wallet.component.html',
  styleUrl: './profile-wallet.component.scss'
})
export class ProfileWalletComponent implements OnInit {
  @Input() profile!: OwnProfileResponse;

  private modalService: ModalService = inject(ModalService);
  private invoiceApiService: InvoiceApiService = inject(InvoiceApiService);

  protected loading: boolean = true;
  protected invoices: InvoiceResponse[] = [];
  protected readonly appRoutes = appRoutes;

  public ngOnInit(): void {
    this.getAllInvoice();
  }

  protected onOpenPaymentModal(): void {
    const modalRef: NgbModalRef = this.modalService.open(PaymentModalComponent, {
      scrollable: true
    });
    if (this.profile.currentBalance <= -1) {
      modalRef.componentInstance.amountInput = this.profile.currentBalance * -1;
    }
  }

  private getAllInvoice() {
    this.invoiceApiService.getAllInvoice().subscribe({
      next: response => {
        this.loading = false;
        this.invoices = response;
      }
    });
  }
}
